import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/avatar5.jpg'
import AVTR2 from '../../assets/avatar6.jpg'
import AVTR3 from '../../assets/avatar8.jpg'
import AVTR4 from '../../assets/avatar9.jpg'
import AVTR5 from '../../assets/avatar7.jpg'


import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/pagination';

const data = [
  {
    avtar: AVTR1,
    name: 'Hemanta Jung Xetri',
    review: 'Hi i m Hemanta Jung Xetri, I m fullstack developer since six years. And currently working as frontend developer Wrohit and his team!!!'
  },
  {
    avtar: AVTR2,
    name: 'Mukesh Khadka',
    review: 'Hi i m Mukesh Khadka, I m backend developer since three years. And currently working as frontend developer Wrohit and his team!!! !'
  },
  {
    avtar: AVTR3,
    name: 'Nitesh Kafle',
    review: 'Hi i m Nitesh Kafle, I m fontend developer since two years. And currently working as frontend developer Wrohit and his team!!!'
  },
  {
    avtar: AVTR4,
    name: 'Vikal Kharal',
    review: 'Hi i m Vikal Kharal, I m fontend developer since Four years. And currently working as frontend developer Wrohit and his team!!!'
  },
  {
    avtar: AVTR5,
    name: 'Saurav Phuyal',
    review: 'Hi i m Saurav Phuyal, I m fontend developer since Four years. And currently working as frontend developer Wrohit and his team!!! '
  },

]

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>About Team members..</h5>
      <h2>Team Members</h2>

      <Swiper className="container testimonials__container"
        // install Swiper modules
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}

      >
        {
          data.map(({ avtar, name, review }, index) => {
            return (
              <SwiperSlide key={index} className="testimonial">
                <div className="client__avatar">
                  <img src={avtar} />
                </div>
                <h5 className='client__name'>{name}</h5>
                <small className='client_review'>{review}</small>
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </section>
  )
}

export default Testimonials